<template>
  <div class="img-box">
    <van-swipe indicator-color="white" class="swiper"  v-if="imgList && imgList.length">
      <van-swipe-item v-for="(item, index) in imgList" :key="index">
        <img class="img-item" :src="item.moduleDetailValue" mode="widthFix"/>
      </van-swipe-item>
    </van-swipe>
    <img class="img-item" v-else src="https://img3.quanyou.com.cn/joyNew/group1/M00/21/D8/rB8LrmVd70OAcnxnAADXBbbRklY668.png" alt="" />
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins],
}
</script>

<style lang="stylus" scoped>
  .img-box {
    display: flex;
    width: 330px;
    height: 212px;
    margin: auto;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/9E/rB8LrmU3iLmAEm4sAAA9sXeh0bI817.png');
    background-size: 100% 100%;
    .swiper {
      width: 314px;
      height: 196px;
      margin: auto;
    }
    .img-item {
      width: 314px;
      height: 196px;
      margin: auto;
    }
  }
</style>